export const empty = ({ commit, getters }) => {
  return new Promise((resolve, reject) => {
    commit('array/SET_LIST', [])
    commit('SET_ERROR_SOURCE', undefined)
    resolve()
  })
}

export const push = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit('array/ADD', payload)
    resolve()
  })
}

export const addGeneralError = ({ commit, state }, payload) => {
  return new Promise((resolve, reject) => {
    if (!state.source) commit('SET_ERROR_SOURCE', 'general')
    else if (state.source !== 'general') return reject(new Error())
    commit('array/ADD', payload)
    resolve()
  })
}

export const addServerError = ({ commit, state }, payload) => {
  return new Promise((resolve, reject) => {
    if (!state.source) commit('SET_ERROR_SOURCE', 'server')
    else if (state.source !== 'server') return reject(new Error())
    if (payload.html) commit('SET_HTML_ERROR', true)
    if (!payload.msg) payload.msg = 'Operativa temporalmente no disponible.'
    commit('array/ADD', payload)
    resolve()
  })
}

export const addValidationError = ({ commit, state }, payload) => {
  return new Promise((resolve, reject) => {
    if (!state.source) commit('SET_ERROR_SOURCE', 'validation')
    else if (state.source !== 'validation') {
      try {
        throw new Error()
      } catch (err) {
        return new Error()
      }
    }
    commit('array/ADD', payload)
    resolve()
  })
}

export const addExpirationError = ({ commit, state }, payload) => {
  return new Promise((resolve, reject) => {
    if (!state.source) commit('SET_ERROR_SOURCE', 'expiration')
    else if (state.source !== 'expiration') return reject(new Error())
    commit('array/ADD', payload)
    resolve()
  })
}

export const addMaxFreeIssuedError = ({ commit, state }, payload) => {
  return new Promise((resolve, reject) => {
    if (!state.source) commit('SET_ERROR_SOURCE', 'maxFreeIssued')
    else if (state.source !== 'maxFreeIssued') return reject(new Error())
    commit('array/ADD', payload)
    resolve()
  })
}

export const sort = ({ commit, state }) => {
  commit('array/SET_LIST',
    state.array.list.sort((a, b) => a['id'] - b['id'])
  )
}
